module.exports = __webpack_public_path__ + "files/17eb2a61891716d2035d5051240a420c.png";